import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { createAnalysis } from "../../services/api";
import { CameraIcon, GalleryIcon, UploadIcon } from "../Icons";
import "./Capture.css";

export default function Capture() {
  const navigate   = useNavigate();
  const cameraRef  = useRef(null);
  const galleryRef = useRef(null);
  const [preview,  setPreview]  = useState(null);
  const [file,     setFile]     = useState(null);
  const [label,    setLabel]    = useState("");
  const [location, setLocation] = useState("");
  const [batch,    setBatch]    = useState("");
  const [notes,    setNotes]    = useState("");
  const [isCalibration, setIsCalibration] = useState(false);
  const [clientType, setClientType] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  const handleFile = (f) => {
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
    setError("");
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const f = e.dataTransfer.files[0];
    if (f && f.type.startsWith("image/")) handleFile(f);
  };

  const handleSubmit = async () => {
    if (!file)       return setError("Selecione uma imagem.");
    if (!label)      return setError("Informe um nome para a análise.");
    if (!clientType) return setError("Selecione o tipo de cliente.");
    setLoading(true);
    setError("");
    const form = new FormData();
    form.append("file",     file);
    form.append("label",    label);
    form.append("location", location);
    form.append("batch",    batch);
    form.append("notes",    notes);
    form.append("is_calibration", isCalibration);
    form.append("client_type", clientType);
    try {
      const result = await createAnalysis(form);
      navigate(`/analysis/${result.id}`, { state: result });
    } catch (err) {
      setError(err.response?.data?.detail || "Erro ao processar a imagem.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="capture-page">
      <div className="page-header">
        <p className="page-eyebrow">Nova análise</p>
        <h1 className="page-title">Enviar amostra</h1>
        <p className="page-desc">
          Fotografe a coalhada sobre a bandeja de referência com a ring light ativa.
        </p>
      </div>

      <div className="capture-body">
        <div className="capture-source-buttons">
          <button type="button" className="btn-source" onClick={() => cameraRef.current.click()}>
            <CameraIcon size={18} /> Tirar foto
          </button>
          <button type="button" className="btn-source" onClick={() => galleryRef.current.click()}>
            <GalleryIcon size={18} /> Escolher da galeria
          </button>
        </div>

        <div
          className={`dropzone ${preview ? "has-preview" : ""}`}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
        >
          {preview ? (
            <img src={preview} alt="Preview" className="preview-img" />
          ) : (
            <div className="dropzone-placeholder">
              <span className="dropzone-icon"><UploadIcon size={30} /></span>
              <p>Arraste a imagem ou use um dos botões acima</p>
              <span className="dropzone-hint">JPEG ou PNG · máx. 15 MB</span>
            </div>
          )}
          <input
            ref={cameraRef}
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: "none" }}
            onChange={(e) => handleFile(e.target.files[0])}
          />
          <input
            ref={galleryRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => handleFile(e.target.files[0])}
          />
        </div>

        <div className="capture-form">
          <div className="field">
            <label>Identificação da análise *</label>
            <input
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              placeholder="ex: Novonesis · Lote 24A · Laticínio São João"
            />
          </div>
          <div className="field">
            <label>Tipo de cliente *</label>
            <div className="client-type-toggle">
              <button
                type="button"
                className={clientType === "amostra" ? "toggle-option active" : "toggle-option"}
                onClick={() => setClientType("amostra")}
              >
                Amostra
              </button>
              <button
                type="button"
                className={clientType === "campo" ? "toggle-option active" : "toggle-option"}
                onClick={() => setClientType("campo")}
              >
                Campo
              </button>
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Laticínio</label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                placeholder="Nome do laticínio"
              />
            </div>
            <div className="field">
              <label>Lote</label>
              <input
                type="text"
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
                placeholder="Número do lote"
              />
            </div>
          </div>
          <div className="field">
            <label>Observações</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Condições de captura, temperatura, observações técnicas..."
              rows={3}
            />
          </div>
          <label className="field-checkbox">
            <input
              type="checkbox"
              checked={isCalibration}
              onChange={(e) => setIsCalibration(e.target.checked)}
            />
            Análise de calibração
          </label>
        </div>

        {error && <div className="capture-error">{error}</div>}

        <button
          className="btn-analyze"
          onClick={handleSubmit}
          disabled={loading || !file || !label || !clientType}
        >
          {loading ? <><span className="spinner" /> Processando...</> : "Processar imagem"}
        </button>
      </div>
    </div>
  );
}
